// extracted by mini-css-extract-plugin
module.exports = {"cvNavBackground":"#1c2430","trigger":"style__trigger__Bndfa","menuContainer":"style__menuContainer__yVE5I","menu":"style__menu__sBEBc"};